import * as Util from "../common/util";
import * as Data from "../interfaces/data";
import { ITranslatedText } from "../interfaces/translations";
import { ICustomerDocument } from "./documentLibraryData";

export interface ITemplateForm {
    /// unique ID for the template form
    ID: number;

    /// the name of the form
    FormName: string;
    FormDescription: string;
    FormTypeID: number;
    IsActive: boolean;
    FormItems: ITemplateFormItem[];
}

export interface ITemplateControlTypeAttribute {
    ID: number;
    MinVal: string;
    MaxVal: string;
    Format: string;
    MinLength: string;
    MaxLength: string;
    NumDecimals: number;
    NumericDefaultValue: number;
    Interval: number;
}

export interface ITemplateFormItem {
    /// unique ID for the template form
    ID: number;
    /// the title of the form item
    FormText: string;
    FormTextTranslations: ITranslatedText[];
    TemplateFormID: number;
    TemplatePhraseID?: number;
    TemplateAdditionalFormID: number;
    ControlTypeID: number;
    IsRequired: boolean;
    SortOrder?: number;
    IsReadOnly: boolean;
    IsVisible: boolean;
    IsActive: boolean;
    MultipleAdditionalForms: boolean;
    CopyAnswerWhenCloningTask: boolean;
    ShowOnCalendar: boolean;
    TargetTemplateID?: number;
    Fields: ITemplateField[];
    TemplateFormItemDocumentTypeAllowed: ITemplateFormItemDocumentTypeAllowed[];
    TemplateControlTypeAttribute?: ITemplateControlTypeAttribute;
    LinkedCustomerDocuments: ITemplateFormItemLinkedCustomerDocument[];
    IsAdditionalFormMissing?: boolean;
    MinMaxInvalid?: boolean;
    ExternalName: string;
    ReportName: string;

    // Slider  control fields
    ValidNumericDefaultValue?: boolean;
    ValidInterval?: boolean;

    selected?: KnockoutObservable<number>;
    newFieldText?: KnockoutObservable<string>;
    displayTemplateName?: KnockoutObservable<string>;
    IsEdit: boolean;
    PhraseOrCustomChoice: string;
}

export interface ITemplateFormItemDocumentTypeAllowed {
    TemplateFormItemID: number;
    DocumentFileTypeAllowedID: number;
    DocumentTypeExtension: string;
    Description: string;
    IsActive: boolean;
}

export interface ITemplateFormItemLinkedCustomerDocument {
    TemplateFormItemCustomerDocumentID: number;
    CustomerDocumentID: number;
    IsActive: boolean;
    Description: string;
    FileName: string;
}

export interface ITemplateField {
    ID: number;
    FieldText: string;
    FieldValue: string;
    SortOrder: number;
    HasException: boolean;
    HasExceptionForm: boolean;
    IsActive: boolean;
    TemplateFormID: number|null;
}

export interface ITemplateFormMaster {
    ID: number;
    FormName: string;
    FormDescription: string;
    FormTypeID: number;
    IsActive: boolean;
    DocumentFileTypes: IDocumentFileTypeAllowed[];
    FormItems: ITemplateFormItem[];
    ControlTypes: IControlType[];
    AdditionalForms: Array<Data.ICodeModel<number>>;
    TemplatePhrases: Array<Data.ICodeModel<number>>;
    FormTypes: Array<Data.ICodeModel<number>>;
    TargetTemplates: Array<Data.ICodeModel<number>>;
    CustomerDocuments: ICustomerDocument[];
}

export interface IControlType {
    ID: number;
    Name: string;
    // Optionally holds different formatting options for the control type.
    // For example, Text boxes can be formatted as SSN or zip codes.
    Formats: IFormatMask[];
}

export interface IFormatMask {
    ID: number;
    UniqueID: string;
    Description: string;
    WebMask: string;
}

export interface IDocumentFileTypeAllowed {
    ID: number;
    Description: string;
    IsActive: boolean;
    DocumentTypeExtension: string;
}
export interface ITemplateFormRequest {
    TemplateFormID: number;
}
export interface ITemplateFormResponse {
    ID: number;
}

export function GetTemplateForm(request: ITemplateFormRequest): JQueryDeferred<Data.IResponse<ITemplateFormMaster>> {
    return Util.callWebService(
        "/api/TemplateForm/GetTemplateForm", "POST", request);
}

export function SaveTemplateForm(templateForm: any): JQueryDeferred<Data.IResponse<ITemplateFormResponse>> {
    return Util.callWebService(
        "/api/TemplateForm/SaveTemplateForm", "POST", templateForm);
}

export function CopyForm(ID: any): JQueryDeferred<Data.IResponse<number>> {
    return Util.callWebService(
        "/api/TemplateForm/CopyForm", "POST",
        {
            ID,
        });
}

export function ChangeFormStatus(templateFormID: number, isActive: boolean): JQueryDeferred<Data.IResponse<any>> {
    return Util.callWebService(
        "/api/TemplateForm/ChangeFormStatus",
        "POST",
        {
            ID: templateFormID,
            IsActive: isActive,
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/data/templateFormData.ts